import { useState } from 'react';
import { auditDownloadEndpoint, getAuditAccess } from './auditLeadAccess';
import { trackGa4Event } from './analytics';

export default function AuditDownloadButton({ className, children = 'Download companion PDF' }) {
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState('');
  const download = async () => {
    if (busy) return;
    setBusy(true);
    setError('');
    try {
      const access = getAuditAccess();
      if (!access) throw new Error('Your access expired. Request the audit again using your email.');
      const response = await fetch(auditDownloadEndpoint, { method: 'POST', headers: { Authorization: `Bearer ${access.token}` } });
      if (!response.ok) throw new Error('Unable to download. Request the audit again using your email.');
      const blob = await response.blob();
      if (blob.type !== 'application/pdf' || !blob.size) throw new Error('The PDF is unavailable. Please try again.');
      const url = URL.createObjectURL(blob);
      const link = document.createElement('a');
      link.href = url;
      link.download = 'ReportWerks-Marketing-Data-Confidence-Audit.pdf';
      document.body.appendChild(link);
      link.click();
      link.remove();
      setTimeout(() => URL.revokeObjectURL(url), 60000);
      trackGa4Event('file_download', {
        file_name: 'ReportWerks-Marketing-Data-Confidence-Audit.pdf',
        file_extension: 'pdf',
        source_component: 'audit_download',
        page_location: window.location.origin + window.location.pathname,
      });
    } catch (failure) { setError(failure.message); }
    finally { setBusy(false); }
  };
  return <span><button type="button" className={className} disabled={busy} onClick={download}>{busy ? 'Downloading…' : children}</button>{error ? <span role="alert">{error} <a href="/marketing-data-confidence-audit#download">Request access</a></span> : null}</span>;
}
